import { get } from './fetchUtils';
export type showToastType = (showToast: any) => void;
export type StateFilterParams = {
  selectedSessionNames: string[];
  selectedCountries: string[];
  startDate: number;
  endDate: number;
  dataSource: string;
};
export type DistrictFilterParams = {
  selectedSessionNames: string[];
  selectedCountries: string[];
  selectedStates: string[];
  startDate: number;
  endDate: number;
  dataSource: string;
};
export type BlockFilterParams = {
  selectedSessionNames: string[];
  selectedCountries: string[];
  selectedStates: string[];
  selectedDistricts: string[];
  startDate: number;
  endDate: number;
  dataSource: string;
};
export type ClusterFilterParams = {
  selectedSessionNames: string[];
  selectedCountries: string[];
  selectedStates: string[];
  selectedDistricts: string[];
  selectedBlocks: string[];
  startDate: number;
  endDate: number;
  dataSource: string;
};
export type SchoolGroupFilterParams = {
  selectedSessionNames: string[];
  selectedCountries: string[];
  selectedStates: string[];
  selectedDistricts: string[];
  selectedBlocks: string[];
  selectedClusters: string[];
  startDate: number;
  endDate: number;
  dataSource: string;
};
export type SchoolIdsFilterParams = {
  selectedSessionNames: string[];
  selectedCountries: string[];
  selectedStates: string[];
  selectedDistricts: string[];
  selectedBlocks: string[];
  selectedClusters: string[];
  selectedSchoolGroups: string[];
  startDate: number;
  endDate: number;
  dataSource: string;
};
export type GradesFilterParams = {
  selectedSchoolIds: string[];
  startDate: number;
  endDate: number;
  dataSource: string;
};
export type SessionFilterParams = {
  startDate: number;
  endDate: number;
  dataSource: string;
};
export type CountryFilterParams = {
  selectedSessionNames: string[];
  startDate: number;
  endDate: number;
  dataSource: string;
};
export const getDistinctStates = (
  stateFilterParams: StateFilterParams,
  showToast: showToastType
) => {
  return get(
    `api/dashboard/distinct-state-names`,
    stateFilterParams,
    showToast
  );
};
export const getDistinctSessionNames = (
  sessionFilterParams: SessionFilterParams,
  showToast: showToastType
) => {
  return get(
    `api/dashboard/distinct-session-names`,
    sessionFilterParams,
    showToast
  );
};
export const getDistinctCountries = (
  countryFilterParams: CountryFilterParams,
  showToast: showToastType
) => {
  return get(
    `api/dashboard/distinct-country-names`,
    countryFilterParams,
    showToast
  );
};
export const getDistinctDistricts = (
  districtFilterParams: DistrictFilterParams,
  showToast: showToastType
) => {
  return get(
    `api/dashboard/distinct-district-names`,
    districtFilterParams,
    showToast
  );
};
export const getDistinctBlocks = (
  blockFilterParams: BlockFilterParams,
  showToast: showToastType
) => {
  return get(
    `api/dashboard/distinct-block-names`,
    blockFilterParams,
    showToast
  );
};
export const getDistinctClusters = (
  clusterFilterParams: ClusterFilterParams,
  showToast: showToastType
) => {
  return get(
    `api/dashboard/distinct-cluster-names`,
    clusterFilterParams,
    showToast
  );
};
export const getDistinctSchoolGroups = (
  schoolGroupFilterParams: SchoolGroupFilterParams,
  showToast: showToastType
) => {
  return get(
    `api/dashboard/distinct-school-group-names`,
    schoolGroupFilterParams,
    showToast
  );
};
export const getDistinctSchoolIds = (
  schoolIdFilterParams: SchoolIdsFilterParams,
  showToast: showToastType
) => {
  return get(
    `api/dashboard/distinct-school-ids`,
    schoolIdFilterParams,
    showToast
  );
};
export const getDistinctGradesNames = (
  gradesFilterParams: GradesFilterParams,
  showToast: showToastType
) => {
  return get(
    `api/dashboard/distinct-grades-names`,
    gradesFilterParams,
    showToast
  );
};
